import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {MustMatch} from "@shared/services/web/must-match.validator";
import {ActivatedRoute, Router} from "@angular/router";
import {PropertiesService} from "@shared/services/api/properties.service";
import {CredentialsService} from "@shared/services/web/credentials.service";
import {ToastrService} from "@shared/services/web/toastr.service";
import {TranslateService} from "@ngx-translate/core";
import {RedirectRouterService} from "@shared/services/web/redirect-router.service";
import {CookieService} from "ngx-cookie-service";
import {UsersService} from "@shared/services/api/users-account.service";
import { Buffer } from 'buffer';

@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss']
})
export class CreatePasswordComponent implements OnInit  {
  showPassword = true;
  loading = false;
  verifiedUser = false;
  noEmail = false;
  currentUser: any;
  acceptNotifications = false;
  formToCreatePassword = new FormGroup(
    {
      email: new FormControl({ value: '', disabled: true }),
      id_user: new FormControl(''),
      password: new FormControl('', Validators.required),
      repeat_password: new FormControl('', Validators.required),
      first_name: new FormControl('', [
        Validators.required,
        Validators.pattern('^[A-ZñÑa-zÁ-ÿ0-9\\s]+$'),
        Validators.maxLength(30),
      ]),
      last_name: new FormControl('', [
        Validators.required,
        Validators.pattern('^[A-ZñÑa-zÁ-ÿ0-9\\s]+$'),
        Validators.maxLength(30),
      ]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern(
          '^[+]?([1-9][0-9]*(?:[\\.][0-9]*)?|0*\\.0*[1-9][0-9]*)(?:[eE][+-][0-9]+)?$'
        ),
        Validators.minLength(8),
      ]),
      code_country: new FormControl(null, []),
      contact_email: new FormControl(false),
      contact_phone: new FormControl(false),
      contact_sms: new FormControl(false),
    },
    {
      validators: MustMatch('password', 'repeat_password') as ValidatorFn,
    }
  );
  cookieHsUtk = '';

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly propertiesService: PropertiesService,
    private readonly usersService: UsersService,
    private readonly toastrService: ToastrService,
    private readonly credentialsService: CredentialsService,
    private readonly translateService: TranslateService,
    private redirectService: RedirectRouterService,
    private cookieService: CookieService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const { q } = this.activatedRoute.snapshot.queryParams;
    if (!q) {
      this.noEmail = true;
      return;
    }
    this.cookieHsUtk = this.cookieService.get('hubspotutk');
    this.currentUser = this.credentialsService.credentials;

    this.currentUser.email = Buffer.from(
      decodeURIComponent(q),
      'base64'
    ).toString('ascii');

    this.verifiedUser = this.currentUser.verified;
    this.formToCreatePassword.get('email').setValue(this.currentUser?.email);
    this.formToCreatePassword
      .get('id_user')
      .setValue(this.currentUser?.id_user);
    this.verifiedUser = true;
    this.usersService
      .getUserById(this.currentUser.id_user)
      .subscribe((resp) => {
        this.formToCreatePassword
          .get('first_name')
          .setValue(resp?.person.first_name);
        this.formToCreatePassword
          .get('last_name')
          .setValue(resp?.person.last_name);
        this.formToCreatePassword
          .get('phone')
          .setValue(resp?.person.phone?.number);
        this.formToCreatePassword
          .get('code_country')
          .setValue(resp?.person.phone?.code_country);
        this.acceptNotifications = resp?.receiveNotifications;
      });
  }

  hidePassword(): void {
    this.showPassword = !this.showPassword;
  }
  save(): void {
    if (!this.formToCreatePassword.valid) {
      this.toastrService.info(
        'Complete el formulario correctamente',
        'Validación'
      );
      return;
    }
    if (
      !(
        this.formToCreatePassword.get('contact_email').value ||
        this.formToCreatePassword.get('contact_phone').value ||
        this.formToCreatePassword.get('contact_sms').value
      )
    ) {
      this.toastrService.info(
        'Complete el formulario correctamente',
        'Validación'
      );
      return;
    }

    const userEdit = {
      id_user: this.formToCreatePassword.get('id_user').value,
      email: this.formToCreatePassword.get('email').value,
      password: this.formToCreatePassword.get('password').value,
      repeat_password: this.formToCreatePassword.get('repeat_password').value,
      receiveNotifications: true,
      receiveNotificationsContent: false,
      receiveNotificationsProcesses: true,
      receiveNotificationsCommercial: false,
      person: {
        first_name: this.formToCreatePassword.get('first_name').value,
        last_name: this.formToCreatePassword.get('last_name').value,
        phone: {
          number: this.formToCreatePassword.get('phone').value,
          code_country: this.formToCreatePassword.get('code_country').value
            ? this.formToCreatePassword.get('code_country').value.phone_code
            : '34',
        },
      },
      contact_email: this.formToCreatePassword.get('contact_email').value,
      contact_phone: this.formToCreatePassword.get('contact_phone').value,
      contact_sms: this.formToCreatePassword.get('contact_sms').value,
      cookieHsUtk: this.cookieHsUtk,
    };
    if (this.acceptNotifications) {
      userEdit.receiveNotificationsContent = true;
      userEdit.receiveNotificationsCommercial = true;
    }
    this.loading = true;
    this.propertiesService.editUserPersonData(userEdit).subscribe({
      next:(data) => {
        this.credentialsService.setCredentials({...this.currentUser, verified: true});
        this.loading = false;
        this.toastrService.success(
          'Contraseña creada correctamente',
          'Actualización de información'
        );
        this.router.navigate([
          `/${this.translateService.currentLang}/invertir`,
        ]);
      },
      error:() => {
        this.loading = false;
        this.toastrService.error(
          'No se pudo actualizar sus contraseñas',
          'Actualización de información'
        );
      }
    });
  }

  gotoHome() {
    this.redirectService.goToPage('/');
  }
}
